import { render, staticRenderFns } from "./UnknownError.vue?vue&type=template&id=bc1f2378"
import script from "./UnknownError.vue?vue&type=script&lang=js"
export * from "./UnknownError.vue?vue&type=script&lang=js"
import style0 from "./UnknownError.vue?vue&type=style&index=0&id=bc1f2378&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports